import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'
import z from 'zod/v3'
import AddEntreprisePage1 from '../../../components/routes/companies/AddEntreprisePage1'
import AddEntreprisePage2 from '../../../components/routes/companies/AddEntreprisePage2'
import EntrepriseOutletProvider from '../../../components/routes/companies/EntrepriseOutletProvider'
import { stepsSchema, type Step } from './new'

import { withResourcePermission } from '../../../components/RequireResourcePermission'
export const Route = createFileRoute('/_authenticated/companies/$id/edit')({
  component: withResourcePermission('work-concil', 'read')(RouteComponent),
  validateSearch: z.object({
    step: stepsSchema,
  }),
})

const stepComponents = {
  1: AddEntreprisePage1,
  2: AddEntreprisePage2,
} satisfies Record<Step, () => JSX.Element>

function RouteComponent() {
  const { step } = Route.useSearch()
  const { id } = Route.useParams()
  const worksConcilId = parseInt(id, 10)

  const Component = stepComponents[step]

  return (
    <EntrepriseOutletProvider worksConcilId={worksConcilId}>
      <Component />
    </EntrepriseOutletProvider>
  )
}
